// extracted by mini-css-extract-plugin
export var label = "_if-2";
export var slideContainer = "_if-0";
export var slider = "_if-1";